import React from 'react'
import Link from 'next/link'
import type { StickyBannerItemFragment } from '../../../.graphql/generated-types'

export interface ComposeComponentStickyBannerItemProps {
  data: StickyBannerItemFragment
}

export function ComposeComponentStickyBannerItem({
  data,
}: ComposeComponentStickyBannerItemProps) {
  if ((data.heading ?? data.body) && data.link?.url) {
    const {
      heading,
      body,
      link: { text: linkText, url: href },
    } = data
    return (
      <Link href={href} passHref={true}>
        {heading && <div className="p-0 text-center font-bold">{heading}</div>}
        {body && (
          <div className="p-0 text-center text-sm">
            {body} <span className="underline">{linkText}</span>
          </div>
        )}
      </Link>
    )
  }
  return null
}
